require('./components/LegacyReactTemplates/listAccounts.jsx');
require('./components/LegacyReactTemplates/listActivities.jsx');
require('./components/LegacyReactTemplates/listAppointment.jsx');
require('./components/LegacyReactTemplates/table.jsx');
require('./components/LegacyReactTemplates/listSoliditet.jsx');
require('./components/LegacyReactTemplates/listOrders.jsx');
require('./components/LegacyReactTemplates/viewPicker.jsx');
require('./components/LegacyReactTemplates/accountChartSales.jsx');
require('./components/LegacyReactTemplates/accountChartMarket.jsx');
require('./components/LegacyReactTemplates/Loader.jsx');
require('../components/Flash/root.jsx');
require('../components/Flash/topList.jsx');
require('../components/Flash/shield.jsx');
require('../components/Flash/resultView.jsx');
require('../components/Flash/clockWidget.jsx');
require('./components/LegacyReactTemplates/voice/root.jsx');
require('./components/LegacyReactTemplates/voice/dialing.jsx');
require('./components/LegacyReactTemplates/voice/inCall.jsx');
require('./components/LegacyReactTemplates/voice/followup.jsx');
require('./components/LegacyReactTemplates/inputWrappers.jsx');
require('./components/LegacyReactTemplates/upCountry.jsx');
// Moved out of upsales/ for the React edit-activity modal port (WEB-8899);
// still required here because the Angular modal mounts them through the
// ReactTemplates.editActivity globals they register. root.jsx initialises the
// namespace, so it stays first.
require('../components/Flash/ActivityEditor/root.jsx');
require('../components/Flash/ActivityEditor/footer.jsx');
require('../components/Flash/ActivityEditor/sidebarAccount.jsx');
require('../components/Flash/ActivityEditor/sidebarContact.jsx');
require('../components/Flash/ActivityEditor/header.jsx');
require('./components/LegacyReactTemplates/alerts.jsx');
require('./components/LegacyReactTemplates/AddProductCategory.jsx');
